module.exports = __webpack_public_path__ + "img/case24.45454912.png";